module.exports = __webpack_public_path__ + "static/media/snap_send_email.1db1df18.svg";